'use client';

import { FC } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from 'src/utils/getOr';

import { InputFormProps } from './Input.type';
import { InputSelect } from './InputSelect';

/**
 * Select field expected to be used within a React Form
 */
export const InputSelectForm: FC<InputFormProps<typeof InputSelect>> = ({
  id,
  name,
  disabled,
  formState,
  ...props
}) => {
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();

  return <InputSelect {...props} id={inputId} name={name} error={error} disabled={disabled || pending} />;
};
